import ProductTag from 'components-v2/organisms/pages/landingPageCam/mocules/ProductTag';
import { useTranslation } from 'next-i18next';
import { getTagLabel } from 'utils/TagUtils';

/**
 * Render một tag đã được resolve từ registry CMS.
 *
 * Component này cố tình KHÔNG nhận code thô và KHÔNG tự tra store: việc lọc/sắp xếp/alias
 * nằm ở utils/TagUtils, được TagComponent gọi một lần cho cả sản phẩm. Nhờ vậy tránh được
 * hai lỗi cũ: tra store lặp lại cho từng tag, và ghi đè (mutate) thẳng vào object trong store.
 */
const TagType = ({ tag, index, link, isLinkTagDeal }) => {
  const { t: translateCommon } = useTranslation('common');

  if (!tag?.code) return null;

  const name = getTagLabel({ tag, t: translateCommon });
  if (!name) return null;

  return (
    <ProductTag
      code={tag.code}
      name={name}
      slug={tag.slug}
      textColor={tag.textColor}
      preIcon={tag.preIcon}
      nameAsTooltip={tag.nameAsTooltip}
      style={tag.style}
      index={index}
      link={link}
      isLinkTagDeal={isLinkTagDeal}
    />
  );
};

export default TagType;
